import { writable } from 'svelte/store';

// Read a JSON-encoded value from localStorage at module-load time so the
// store starts already populated. The previous design used an after-the-fact
// `useLocalStorage()` call from each component, which left a race window
// where `$user` briefly resolved to `{}` between writable creation and the
// first hydration call — and that window was visible on SPA navigation as
// a "logged-out flash" in the header and on Home.
function readStored(key, fallback) {
  if (typeof localStorage === 'undefined') return fallback;
  try {
    const json = localStorage.getItem(key);
    return json ? JSON.parse(json) : fallback;
  } catch {
    return fallback;
  }
}

function createPersistedStore(key, fallback) {
  const store = writable(readStored(key, fallback));
  if (typeof localStorage !== 'undefined') {
    store.subscribe(value => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {}
    });
  }
  // Backward-compat shim for the old `user.useLocalStorage()` callsites.
  // Persistence is now wired up at module load, so the method is a no-op.
  return {
    subscribe: store.subscribe,
    set: store.set,
    update: store.update,
    useLocalStorage: () => {}
  };
}

export const user = createPersistedStore('user', {});

// Bearer access tokens are deliberately NOT persisted. They have short
// lifetimes and storing them in localStorage would expand the window in
// which a stolen token is replayable. Login.svelte refreshes the token
// on every page load via MSAL silent acquisition.
export const token = writable("");

export const page = writable("");
export const params = writable([]);
